// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    //primary nav links 
	const menuBtn = document.getElementById("js-menu-trigger");
	const menuLinks = document.getElementById("js-menu-links");
	
    if(menuLinks) {
        menuBtn.addEventListener('click', (e) =>{
            e.preventDefault();
            const isOpen = menuLinks.classList.toggle('open');
            menuBtn.innerHTML = isOpen ? 'Close' : 'Menu';
            menuBtn.classList.toggle("active");
        });
    }

    if (window.innerWidth > 600) {
        const primaryLinks = document.querySelectorAll("#privary-navigation li > a:first-child, .primary-nav__extra li > a:first-child");
        primaryLinks.forEach(link => {
            const parentLi = link.closest("li");
            const submenu = parentLi.querySelector(".submenu");

            // Focus / Keyboard
            link.addEventListener("click", (e) => {
                if (submenu) {
                    e.preventDefault();
                    parentLi.classList.add("hover");
                }
            });

            link.addEventListener("blur", function() {
                setTimeout(() => {
                    if (!parentLi.contains(document.activeElement)) {
                        parentLi.classList.remove("hover");
                    }
                }, 100);
            });

            parentLi.addEventListener("mouseenter", function(e) {
                if (e.target.closest(".submenu")) return;

                primaryLinks.forEach(otherLink => {
                    otherLink.closest("li").classList.remove("hover");
                });

                parentLi.classList.add("hover");
            });
        });

        let leaveTimer = null;

        document.querySelectorAll("#primary-nav, .primary-nav__extra").forEach(nav => {
            nav.addEventListener("mouseleave", function() {
                leaveTimer = setTimeout(() => {
                    primaryLinks.forEach(link => {
                        link.closest("li").classList.remove("hover");
                    });
                }, 600);
            });

            nav.addEventListener("mouseenter", function() {
                clearTimeout(leaveTimer);
            });
        });

        document.querySelectorAll(".submenu").forEach(submenu => {
            submenu.addEventListener("mouseenter", function() {
                clearTimeout(leaveTimer);
            });

            submenu.addEventListener("mouseleave", function() {
                leaveTimer = setTimeout(() => {
                    primaryLinks.forEach(link => {
                        link.closest("li").classList.remove("hover");
                    });
                }, 600);
            });
        });
    }
	
    //mobile buger menu 
    const burgerMenuBtn = document.getElementById('js-burger-trigger');
    const burgerMenuClose = document.getElementById('burger-close');
    const burgerMenu = document.getElementById('burger-menu');

    if(burgerMenu) {
        burgerMenuBtn.addEventListener('click', (e) =>{
            e.preventDefault();
            burgerMenu.classList.add('open');
            document.body.classList.add('no-scroll');
        });
    
        burgerMenuClose.addEventListener('click', (e) =>{
            e.preventDefault();
            burgerMenu.classList.remove('open');
            document.body.classList.remove('no-scroll');
        });
        
        burgerMenu.addEventListener("click", (e) => {
			let target = e.target.closest("li");
	
			if (!target)
				return;
	
			target.classList.toggle("active");
		});
    }
	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }

        let timeFields = document.querySelectorAll('.form-module__field.time input');

        if(timeFields.length > 0){
            timeFields.forEach(field => {
                field.addEventListener('click', function() {
                    try {
                        this.showPicker();
                    } catch (error) {
                        console.log("The browser does not support showPicker():", error);
                    }
                });
            });
        }
        
	}

    //accordidon 
    document.querySelectorAll('.accordion').forEach((accordion) => {
        accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
            itemHead.addEventListener('click', (e) => {
                accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                    if (itemHead.parentNode !== item) item.classList.remove('open');
                });
                itemHead.parentNode.classList.toggle('open');
            });
        });
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    window.addEventListener('hashchange', () => {
        const currentHash = window.location.hash;
        
        if (currentHash) {
            const id = currentHash.substring(1);
            const filterButton = document.getElementById(id);
            
            if (filterButton) {
                filterButton.click();
                
            }
        }
    });


    document.addEventListener('DOMContentLoaded', () => {
        if (window.location.hash) {
            setTimeout(() => {
                
                window.dispatchEvent(new Event('hashchange'));
            }, 300);
        }
    });

})();